import React, {useState} from 'react';
import styles from './submission-history.module.scss'
import {useAppSelector} from "../../../../hooks/useAppSelector";
import {Roles} from "../../../../types/roles";
import {formatTableTime} from "../../../../utils/format-table-dates";
import {useTranslation} from "react-i18next";

const SubmissionHistory = () => {
    const { projectLog, selectedRow } = useAppSelector(state => state.masterUtilities)
    const userRoles = useAppSelector(state => state.user.user?.roles)
    const [isExpanded, setIsExpanded] = useState<boolean>(false)
    const {t } = useTranslation()

    const dateTimeFormat = "MM/DD/YYYY hh:mm AM";
    const isContractor = userRoles?.includes(Roles.Contractor)
    const sortedLogs = [...projectLog].sort((a, b) => b.id - a.id);
    const visibleLogs = isExpanded ? sortedLogs : sortedLogs.slice(0, 3);

    return (
        <div className={styles.submissionHistory}>
            <div className={styles.headerRow}>
                <span className={styles.title}>{t('master-utilities.submissionHistory')}</span>
                {sortedLogs.length > 3 && (
                    <button
                        className={styles.toggleButton}
                        onClick={() => setIsExpanded(prev => !prev)}
                    >
                        {isExpanded ? t('master-utilities.hide') : t('master-utilities.seeFullHistory')}
                    </button>
                )}
            </div>
            {projectLog.length > 0 ? (
                <div className={styles.history}>
                    <div className={styles.revisionTimeline}>
                        {visibleLogs
                            .slice()
                            .map((item) => {
                                return (
                                    <div key={item.id} className={styles.revisionEntry}>
                                        <div className={styles.entryContent}>
                                            <div className={styles.userBlock}>
                                            <span className={styles.userName}>
                                                {item.userName !== null
                                                    ? isContractor
                                                        ? t('master-utilities.planningDepartment')
                                                        : item.userName
                                                    : selectedRow?.contractorOrgName}
                                            </span>
                                                <p className={styles.status}>
                                                    {item.eventTypeName}
                                                </p>
                                            </div>
                                            <div className={styles.entryDate}>
                                                {formatTableTime(new Date(item.changedDateTime), dateTimeFormat)}
                                            </div>
                                        </div>
                                        {item.comment && (
                                            <p className={styles.comment}>{item.comment}</p>
                                        )}
                                    </div>
                                )
                            })}
                    </div>
                </div>
            ) : (
                <p className={styles.desc}>{t('master-utilities.importToStartHistory')}</p>
            )}
        </div>
    );
};

export default SubmissionHistory;